// for add employee state
export const ADD_CUSTOMER_DATA = "add_customer_data";
